export default "__VITE_ASSET__90df4cfe__"